//
//
//
//
//
//
//
//
//
//

import MattingAdvancedToolbar from "./MattingAdvancedToolbar";
import MattingAdvancedCanvas from "./MattingAdvancedCanvas";
const { computed } = window.MattingEngineModule;
export default {
  name: "MattingAdvanced",
  components: {
    MattingAdvancedToolbar,
    MattingAdvancedCanvas,
  },
  computed: {
    mattingFsmState: computed.mattingFsmState,
    isShowAdvanced() {
      return this.mattingFsmState && this.mattingFsmState.matches("editing");
    },
  },
  created() {},
};
